import { render, staticRenderFns } from "./TheChangePassword.vue?vue&type=template&id=80fceb94&scoped=true"
import script from "./TheChangePassword.vue?vue&type=script&lang=js"
export * from "./TheChangePassword.vue?vue&type=script&lang=js"
import style0 from "./TheChangePassword.vue?vue&type=style&index=0&id=80fceb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fceb94",
  null
  
)

export default component.exports